"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationFuneralAssistance = function IllustrationFuneralAssistance() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "65",
    height: "65",
    fill: "none",
    viewBox: "0 0 65 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M31.547 28.866V47.056c0 4-6.436 4-6.436 0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    fillRule: "evenodd",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M51 32.03c-1.184-2.017-3.513-3.389-6.193-3.389-3.09 0-5.714 1.824-6.654 4.359-.939-2.535-3.563-4.359-6.653-4.359-3.09 0-5.714 1.824-6.653 4.359-.94-2.535-3.564-4.359-6.654-4.359-2.68 0-5.01 1.372-6.193 3.39C12.954 22.473 21.32 15 31.5 15S50.046 22.473 51 32.03z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M33.348 15.088c3.963 4.593 4.684 17.536 4.684 17.536M29.745 15.088c-3.962 4.593-4.683 17.536-4.683 17.536M31.547 13v1.67"
  }));
};

var _default = IllustrationFuneralAssistance;
exports.default = _default;